import { motion } from "framer-motion";

/**
 * Animated, theme-aware replacement for the static "multi-collection" /
 * bookmark-board screenshots. Renders a real onBookmarks-style panel — window
 * chrome, collection chips and bookmark rows — that animates in on scroll and
 * adapts to light/dark via CSS tokens. No image assets.
 */

const FAVICONS = [
  { letter: "G", name: "GitHub", domain: "github.com", color: "#f59e0b" },
  { letter: "N", name: "Notion", domain: "notion.so", color: "#3b82f6" },
  { letter: "F", name: "Figma", domain: "figma.com", color: "#ef4444" },
  { letter: "V", name: "Vercel", domain: "vercel.com", color: "#10b981" },
];

const COLLECTIONS = ["Development", "Research", "Design", "Reading list"];

const container = {
  hidden: {},
  show: {
    transition: { staggerChildren: 0.09, delayChildren: 0.15 },
  },
};

const row = {
  hidden: { opacity: 0, y: 14 },
  show: { opacity: 1, y: 0, transition: { duration: 0.45, ease: "easeOut" } },
};

const chip = {
  hidden: { opacity: 0, scale: 0.8 },
  show: { opacity: 1, scale: 1, transition: { duration: 0.35, ease: "easeOut" } },
};

export const BookmarkBoardMock = ({ className = "" }) => {
  return (
    <motion.div
      className={`obm-mock obm-mock--board ${className}`}
      variants={container}
      initial={false}
      animate="show"
    >
      <div className="obm-mock__chrome">
        <span className="obm-mock__dot" style={{ background: "#ef4444" }} />
        <span className="obm-mock__dot" style={{ background: "#f59e0b" }} />
        <span className="obm-mock__dot" style={{ background: "#10b981" }} />
        <div className="obm-mock__omnibox">my.onbookmarks.com</div>
      </div>

      <div className="obm-mock__body">
        <motion.div className="obm-mock__chips" variants={container}>
          {COLLECTIONS.map((c, i) => (
            <motion.span
              key={c}
              className={`obm-mock__chip ${i === 0 ? "is-active" : ""}`}
              variants={chip}
            >
              {c}
            </motion.span>
          ))}
        </motion.div>

        <div className="obm-mock__list">
          {FAVICONS.map((f) => (
            <motion.div className="obm-mock__item" key={f.name} variants={row}>
              <span className="obm-mock__fav" style={{ background: f.color }}>
                {f.letter}
              </span>
              <div className="obm-mock__meta">
                <span className="obm-mock__title">{f.name}</span>
                <span className="obm-mock__domain">{f.domain}</span>
              </div>
              <div className="obm-mock__tags">
                <span className="obm-mock__tag" />
                <span className="obm-mock__tag" />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default BookmarkBoardMock;
